var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderPlusSolid = function SvgFolderPlusSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v26h20V15.438l1.719-1.72.281-.312V3H6m2 2h14v8.406l.281.313L24 15.438V27H8zm16 0h2v7.563l-1 1-1-1zm-9 7v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
  })));
};
export default SvgFolderPlusSolid;